export default function ApproachSection() {
  const approaches = [
    {
      icon: 'ri-user-heart-line',
      title: 'Grounded in Real Experience',
      description: 'Built on hands-on rehabilitation experience — supporting people through creative, trauma-informed work.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Trauma-Informed & Safety-Focused',
      description: 'Clear boundaries. Emotional safety.'
    },
    {
      icon: 'ri-brush-line',
      title: 'No Artistic Skills Required',
      description: 'No talent or creativity is needed — the focus is therapeutic processing, not artistic results.'
    },
    {
      icon: 'ri-user-settings-line',
      title: 'Individualized Therapeutic Process',
      description: 'Each session is adapted to your emotional state and life context.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Practical Regulation Tools',
      description: 'Learn grounding, emotional regulation, and stabilization tools applicable outside therapy.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Long-Term, Sustainable Change',
      description: 'A structured therapeutic process aimed at resilience, clarity, and lasting change.'
    }
  ];

  return (
    <section id="art-therapy" className="pt-8 pb-6 lg:pb-12 bg-[#81998C]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-4">
          <h2 
            className="text-4xl lg:text-5xl font-normal cinematic-text-dark mb-4"
          >
            My Approach to Therapy
          </h2>
          <p 
            className="text-lg md:text-xl text-[#385B47]/80 max-w-3xl mx-auto leading-snug md:leading-relaxed"
          >
            A grounded, experience-based therapeutic process focused on safety, regulation, and long-term recovery
          </p>
        </div>
        
        {/* Mobile: Single unified block, Desktop: Multi-column grid */}
        <div className="md:hidden">
          {/* Mobile: Single unified block with vertical list */}
          <div className="bg-[#4E6D70] p-6 rounded-2xl">
            <div className="space-y-6">
              {approaches.map((approach, index) => (
                <div key={index} className="text-left">
                  <div className="w-10 h-10 cinematic-accent-bg rounded-full flex items-center justify-center mb-3">
                    <i className={`${approach.icon} text-lg text-white`}></i>
                  </div>
                  
                  <h3 
                    className="text-lg font-normal cinematic-text-light mb-2"
                  >
                    {approach.title}
                  </h3>
                  
                  <p 
                    className="cinematic-text-light-secondary leading-relaxed text-sm whitespace-pre-line"
                  >
                    {approach.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Desktop: Multi-column grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-5">
          {approaches.map((approach, index) => (
            <div 
              key={index}
              className="bg-[#4E6D70] p-8 lg:p-5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-[#3D5C4A]"
            >
              <div className="w-16 h-16 lg:w-12 lg:h-12 cinematic-accent-bg rounded-full flex items-center justify-center mb-6 lg:mb-3">
                <i className={`${approach.icon} text-2xl lg:text-xl text-white`}></i>
              </div>
              
              <h3 
                className="text-xl lg:text-lg font-normal cinematic-text-light mb-4 lg:mb-2"
              >
                {approach.title}
              </h3>
              
              <p 
                className="cinematic-text-light-secondary leading-relaxed whitespace-pre-line lg:text-sm"
              >
                {approach.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
